(function($){
    $(document).ready(function(){
        if($('.used-coupons-tr').length > 0){
            $('.used-coupons').html('<p class="coupon-head">Użyte kupony:</p><p>'+$('.used-coupons-tr td').html()+'</p>');
        }
    })

})(jQuery)